import './plugins/chart.js';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { useAuthStore } from './store/auth';

// Impor CSS Global
import './assets/css/global.css';

// Impor dan konfigurasi Toast
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);

const toastOptions = {
  position: "top-right",
  timeout: 5000,
};
app.use(Toast, toastOptions);

const authStore = useAuthStore();
authStore.loadStateFromStorage();

app.use(router);
app.mount('#app');